module.exports = __webpack_public_path__ + "gl.229cc1327ae837748a50.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gl.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gl.svg
// module chunks = styles